import { render, staticRenderFns } from "./ChatPage.vue?vue&type=template&id=6a4ee434&scoped=true"
import script from "./ChatPage.vue?vue&type=script&lang=js"
export * from "./ChatPage.vue?vue&type=script&lang=js"
import style0 from "./ChatPage.vue?vue&type=style&index=0&id=6a4ee434&prod&scoped=true&lang=css"
import style1 from "./ChatPage.vue?vue&type=style&index=1&id=6a4ee434&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e7c46a58a2b84365ed6c46ff010356d5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4ee434",
  null
  
)

export default component.exports